import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the FilterAdminUserView.
 * @extends JetView
 */
export default class FilterAdminUserView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for 'Cedula'
                            name: 'Cedula',
                            label: 'Cedula',
                            labelPosition: 'top',
                            placeholder: _('Cedula'), // Placeholder text
                            invalidMessage: _('Usuario is required'), // Validation message
                        },
                        { id: 'grav2', gravity: 2 }, // Gravity element for layout
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container', // CSS class for styling
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing input
                },
            ],
        };

        const buttons = {
            id: 'b2', // ID for the button container
            rows: [
                {
                    margin: 10,
                    responsive: 'b2', // Responsive layout identifier
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity element for layout
                        {
                            view: 'button', // Button to add user
                            value: _('Añadir Usuario'), // Button label
                            type: 'form', // Button type
                            width: screen == 'small' ? 0 : 150, // Conditional width
                            minWidth: 200, // Minimum width
                            hidden: !devConfig.getPermAction('usuariosBloqueadosAdd', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-usuariosBloqueadosAdd', // CSS class for styling
                            click: () => {
                                // Click event handler
                                this.app.callEvent('addUser:button', [[]]); // Trigger add user event
                            },
                        },
                        {
                            view: 'button', // Button to clear form
                            value: _('Limpiar'), // Button label
                            width: screen == 'small' ? 0 : 100, // Conditional width
                            minWidth: 200, // Minimum width
                            click: () => {
                                // Click event handler
                                this.getRoot().clear(); // Clear form values
                            },
                        },
                        {
                            view: 'button', // Button to consult/filter users
                            value: _('Consultar'), // Button label
                            type: 'form', // Button type
                            width: screen == 'small' ? 0 : 100, // Conditional width
                            minWidth: 200, // Minimum width
                            click: () => {
                                // Click event handler
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('adminUser:filter', [filterdata]); // Trigger filter event
                            },
                        },
                    ],
                },
            ],
        };

        return {
            view: 'form', // Main view type
            rows: [upper_section, buttons], // Layout structure
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            if (screen.width < 500) {
                // Check screen width
                $$('grav').hide(); // Hide element if screen is small
                $$('grav2').hide(); // Hide another element if screen is small
            }
        });
    }
}

// FILE DOCUMENTED
